module.exports = __webpack_public_path__ + "img/walk-q11-2-1.00d1ceb7.png";